import api from './api';


export interface IntervalHtfMapping {
  id: number;
  userId: number;
  interval: number;      // scan interval, minutes
  htfInterval: number;   // associated Higher Timeframe, minutes
  createdAt: string;
  updatedAt: string;
}

/**
 * The supported set and the label both come from the shared catalog now — the
 * copy that used to live here was one of ~20 that had drifted apart.
 * Re-exported so existing importers of this module keep working.
 */
export { BUILTIN_INTERVALS as SUPPORTED_INTERVALS, intervalLabel } from '../utils/intervalCatalog';

export const intervalHtfMappingService = {
  /** GET all mappings for the current user (server seeds defaults on first read). */
  async list(): Promise<IntervalHtfMapping[]> {
    const res = await api.get<any>('/interval-htf-mappings');
    return res.data?.data || [];
  },

  /** Upsert a single interval → HTF mapping. */
  async upsert(interval: number, htfInterval: number): Promise<IntervalHtfMapping> {
    const res = await api.put<any>('/interval-htf-mappings', { interval, htfInterval });
    return res.data?.data;
  },

  /** Bulk-upsert many mappings at once. */
  async bulkUpsert(mappings: Array<{ interval: number; htfInterval: number }>): Promise<IntervalHtfMapping[]> {
    const res = await api.put<any>('/interval-htf-mappings/bulk', { mappings });
    return res.data?.data || [];
  },
};
